import _objectSpread from "@babel/runtime/helpers/objectSpread2";
function Enhancement() {
  return {
    wrapperProps: function wrapperProps(props, WrapperComponent) {
      return _objectSpread({
        'data-ui-name': WrapperComponent.displayName
      }, props);
    }
  };
}
export default Enhancement;
//# sourceMappingURL=dataName.mjs.map